'use client';

import { useEffect } from 'react';
import dynamic from 'next/dynamic';
import { RegistrationStatus } from '@/types/pam-api';
import { sendLoginEvent, sendSignupEvent } from '@/features/analytics/datalayer/datalayer';
import { Webengage } from '@/features/webengage';
import useUser from '@/utils/use-user';
import { StorageKey } from './types';
import UserSkeleton from './user-skeleton';
const UserDropdown = dynamic(() => import('./user-dropdown'), {
  loading: () => <UserSkeleton />
});
function UserProfile() {
  const {
    isFetching,
    isError,
    user
  } = useUser();
  useEffect(() => {
    if (!user || !user.registrationStatus) return;
    const isNewUser = user.registrationStatus === RegistrationStatus.NewUser;
    Webengage.identify(user.id ?? '');
    if (isNewUser) {
      Webengage.signup();
      sendSignupEvent();
    } else {
      sendLoginEvent();
    }
  }, [user]);
  useEffect(() => {
    if (!user) return;
    const hasVisited = sessionStorage.getItem(StorageKey.HasSetAttributes);
    if (hasVisited !== 'true') {
      Webengage.setUserAttributes(user);
      sessionStorage.setItem(StorageKey.HasSetAttributes, 'true');
    }
  }, [user]);
  if (isFetching || isError) return <UserSkeleton />;
  return <UserDropdown data-sentry-element="UserDropdown" data-sentry-component="UserProfile" data-sentry-source-file="user-profile.tsx" />;
}
export default UserProfile;